import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './tab-item.component.scss';
var TabItem = /** @class */ (function (_super) {
    tslib_1.__extends(TabItem, _super);
    function TabItem(element) {
        return _super.call(this, element) || this;
    }
    TabItem.prototype.init = function () { };
    TabItem.prototype.bindEvents = function () { };
    return TabItem;
}(Base));
export { TabItem };



//////////////////
// WEBPACK FOOTER
// ./components/tab-item/tab-item.component.ts
// module id = 526
// module chunks = 0